import { render, staticRenderFns } from "./multipleChoice.vue?vue&type=template&id=cc3b8806&scoped=true"
import script from "./multipleChoice.vue?vue&type=script&lang=js"
export * from "./multipleChoice.vue?vue&type=script&lang=js"
import style0 from "./multipleChoice.vue?vue&type=style&index=0&id=cc3b8806&prod&lang=css"
import style1 from "./multipleChoice.vue?vue&type=style&index=1&id=cc3b8806&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3b8806",
  null
  
)

export default component.exports